import { Link } from "react-router-dom";

const PublicFooter = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-maple rounded-lg flex items-center justify-center">
                <span className="text-white font-heading font-bold text-xl">C</span>
              </div>
              <div className="flex flex-col">
                <span className="font-heading font-bold text-lg text-white leading-tight">CanadaTestPrep.ca</span>
                <span className="text-xs text-slate-400 leading-tight">powered by MaplePass</span>
              </div>
            </div>
            <p className="text-sm text-slate-400">
              The #1 Canadian Citizenship Test preparation platform. Pass your exam with confidence.
            </p>
          </div>
          
          {/* Features Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Features</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/features/chapter-practice" className="hover:text-white transition-colors">
                  Chapter Practice
                </Link>
              </li>
              <li>
                <Link to="/features/simulations" className="hover:text-white transition-colors">
                  Test Simulations
                </Link>
              </li>
              <li>
                <Link to="/features/mock-tests" className="hover:text-white transition-colors">
                  Mock Tests
                </Link>
              </li>
              <li>
                <Link to="/features/flashcards" className="hover:text-white transition-colors">
                  Flashcards
                </Link>
              </li>
              <li>
                <Link to="/features/analytics" className="hover:text-white transition-colors">
                  Analytics & Insights
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/#pricing" className="hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="hover:text-white transition-colors">
                  Disclaimer
                </Link>
              </li>
              <li>
                <a href="/api/sitemap.xml" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Sitemap
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © 2026 CanadaTestPrep.ca. Made with love in Canada
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-slate-500 text-sm hover:text-slate-400 transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-slate-500 text-sm hover:text-slate-400 transition-colors">
              Terms
            </Link>
            <Link to="/disclaimer" className="text-slate-500 text-sm hover:text-slate-400 transition-colors">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
